import { mapperModuleMedia, mapperModuleVideo } from '../../../core/data-layer/modules/mappers'
import imageSizes from '../../../core/constants/imageSizes'
import type { MapperOptions } from '#layers/core/types'

export const pageIndustryDetailGenericMapper = (item: any, options: MapperOptions) => {
  const imageOptions = options.imageOptions || { resize: true, lazy: true, sizes: imageSizes.industries11 }

  return {
    image: item.hero?.image ? mapperModuleMedia(item.hero?.image, imageOptions) : null,
    link: {
      title: item.title || '',
      text: item.title || '',
      url: options.getInternalUrl ? options.getInternalUrl(item.sys?.id) : '',
      nuxt: true,
      openInNewWindow: false
    }
  }
}
